"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UncontrolledCollapse = UncontrolledCollapse;
var _core = require("@blueprintjs/core");
var React = _interopRequireWildcard(require("react"));
var _context = require("../../common/context");
var _hooks = require("../../common/hooks");
var _MenuTrigger = require("../menu/MenuTrigger");
var _excluded = ["children"],
  _excluded2 = ["isOpen"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Differs from the Blueprint Collapse as it doesn't allow you to provide
 * the trigger component. I may come to regret this, but for now it makes it
 * much easier for us to use.
 */

function UncontrolledCollapse(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var defaultIsOpen = rest.isOpen,
    collapseProps = _objectWithoutProperties(rest, _excluded2);
  var _useVisibility = (0, _hooks.useVisibility)(defaultIsOpen || false),
    isOpen = _useVisibility.isOpen,
    toggleOpen = _useVisibility.toggleOpen;
  var visibilityValue = React.useMemo(function () {
    return {
      isOpen: isOpen
    };
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_context.VisibilityContext.Provider, {
    value: visibilityValue
  }, /*#__PURE__*/React.createElement(_MenuTrigger.MenuTrigger, {
    onClick: toggleOpen,
    style: {
      padding: '12px'
    }
  }, children[0]), /*#__PURE__*/React.createElement(_core.Collapse, _extends({}, collapseProps, {
    isOpen: isOpen
  }), children[1])));
}